import { Injectable, inject } from '@angular/core';
import { CacheService, IsFollowing } from '@outlaw/core';
import { CommunityConfigService } from '../util';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class FollowGroupService {
  cacheService = inject(CacheService);
  followGroupUrl = inject(CommunityConfigService).internalApi.followGroup;
  #http = inject(HttpClient);

  followGroup(groupId: string): Observable<void> {
    return this.#http.post<void>(`${this.followGroupUrl}/follow/${groupId}/`, {});
  }

  unfollowGroup(groupId: string): Observable<void> {
    return this.#http.delete<void>(`${this.followGroupUrl}/unfollow/${groupId}/`, {});
  }

  isFollowed(groupId: string): Observable<IsFollowing> {
    return this.#http.get<IsFollowing>(`${this.followGroupUrl}/is_following/${groupId}/`);
  }
}
